import { controls, currencyToNumber, grouped } from "../../controls";

const department_bill = {
  label: "Department Bill",
  starting: true,
  url: "department_bill",
  pageLabel: "Department Bill",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "general", label: "Department", star: false }),
    ...controls.oc({
      tab: "general", c: "Department", placeHolder: "Department Code", name: "department_code", fastpath: "departments", hidden: false
    }),
    //displayData: { salary_bank_name: "salary_bank_name", salary_ac_no: "salary_ac_no" }}),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "department_display" }),

    ...controls.magicDateLabel({ label: "Date", target: "Salary Month" }),
    ...controls.magicDate({ dateType: "ontype", default: "n", isRequired: true, name: "salary_month", width: "col-sm-2", displayFormat: "MMMM yyyy" }),
    ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Department Bill",
    filterable: true,
    sortable: true,
    //defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait",
      header: [
        [{ source: 'fixed', value: 'DEPARTMENT' }, { source: 'fixed', value: '::' }, { field: 'department_display' }, { source: 'fixed', value: '\n' },
        { source: 'fixed', value: 'SALARY MONTH' }, { source: 'fixed', value: '::' }, { field: 'as_on_date', type: 'salary_month' }]
      ],
    },
    // pivot: true,
    extraRows: {
      location: "top",
      fields: ["discriptions"],
      subtotals: {
        by: "col1",
        displayIn: "Details",
      },
      // grandtotal: { type: "fixed", displayIn: "Details", val: "Grand Total", count: true },
      // fixedTotals:[{by:"rows",rows:[1,2,3]}]
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Description",
        accessor: "Details",
        rwidth: "*",

      },
      {
        Header: "Amount",
        accessor: "discriptions",
      },

    ]
  }
};

export default department_bill;